import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Plus, User, ArrowRight } from "lucide-react";

export default function FPBeneficiaryList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/fp/beneficiaries").then((r) => setList(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8" data-testid="fp-beneficiary-list">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#0B2B62]">Meus familiares</h1>
        <Link to="/filho-presente/familiares/novo" data-testid="fp-add-beneficiary"
          className="inline-flex items-center gap-2 bg-[#0B2B62] text-white px-4 py-2 rounded-lg hover:bg-slate-800 text-sm">
          <Plus className="w-4 h-4" /> Cadastrar familiar
        </Link>
      </div>

      {loading ? <div className="text-slate-500">Carregando…</div>
        : list.length === 0 ? (
          <div className="bg-white border-2 border-dashed border-slate-300 rounded-xl p-10 text-center">
            <User className="w-10 h-10 text-slate-400 mx-auto mb-3" />
            <div className="text-slate-700 font-medium mb-1">Nenhum familiar cadastrado</div>
            <div className="text-slate-500 text-sm">Cadastre o beneficiário para começar a organizar os cuidados.</div>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {list.map((b) => (
              <Link key={b.id} to={`/filho-presente/familiares/${b.id}`} data-testid={`fp-benef-card-${b.id}`}
                className="bg-white border border-slate-200 rounded-xl p-5 hover:border-[#0B2B62] hover:shadow-md transition-all">
                <div className="flex items-center gap-3 mb-3">
                  {b.photo_url ? (
                    <img src={b.photo_url} alt="" className="w-12 h-12 rounded-full object-cover" />
                  ) : (
                    <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-bold">
                      {(b.name || "?").charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-slate-800 truncate">{b.name}</div>
                    <div className="text-xs text-slate-500 truncate">{b.relation_to_owner || "—"}</div>
                  </div>
                </div>
                <div className="text-xs text-slate-600 space-y-1">
                  {b.city && <div>{b.city}{b.state && `/${b.state}`}</div>}
                  {b.phone && <div>{b.phone}</div>}
                </div>
                <div className="mt-3 text-xs text-[#0B2B62] font-medium inline-flex items-center gap-1">
                  Abrir perfil <ArrowRight className="w-3 h-3" />
                </div>
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}
